export default __webpack_public_path__ + "static/media/480_dummy2016-ernaehrungsberatung.31d4f8bb.png";